import { render, staticRenderFns } from "./clock-in-modal.vue?vue&type=template&id=396a498b&"
import script from "./clock-in-modal.vue?vue&type=script&lang=js&"
export * from "./clock-in-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports